export default __webpack_public_path__ + "static/media/12WBTLifestyleLogo.e6a64532.png";